import React from "react";
import { Modal, Table } from "antd";

const CostomerItem = ({ visible, onClose, onRowClick, data1 }) => {
  console.log(data1);
  const columns = [
    { title: "Req Date", dataIndex: "req_date", key: "req_date" },
    { title: "Req Code", dataIndex: "req_code", key: "req_code" },
    {
      title: "Employee Name",
      dataIndex: "emp_cd",
      key: "emp_cd",
    },
    { title: "Department", dataIndex: "dept", key: "dept" },
    // { title: "Contract Qty", dataIndex: "sauda_qty", key: "sauda_qty" },
    // { title: "Contract Rate", dataIndex: "sauda_rate", key: "sauda_rate" },
  ];

  return (
    <Modal
      title="Select Here"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={900}
    >
      <Table
        dataSource={data1}
        columns={columns}
        onRow={(record) => {
          return {
            onClick: () => {
              onRowClick(record);
              onClose();
            },
          };
        }}
      />
    </Modal>
  );
};

export default CostomerItem;
